import { toastIds } from '@mobi/account/Utils/constants'
import { addToast } from '@mobi/component-library/Feedback/Toast'

export const FeedbackWithdrawalChannelChange = () => {
  addToast({
    id: toastIds.withdrawalChannelChange,
    isDismissable: true,
    title:
      "We're sorry, there is a delay with the transfer. It may take up to 2 days for the funds to reach your bank account.",
    icon: 'info',
    timeoutMs: 6_000, // 6s
  })
}
